import Subject from "../cse4sub/Subject";
import React from 'react'
//import cse from '../assets/CSE506end21 .pdf'
import cse from '../assets/CSE506end21.pdf'

export default function DaaLab() {
  return (
    <div>
       <Subject title="Design & Analysis Algorithms Lab(CSE506)"
    book1="Data Structures and java collections frame work, W.J.Collins, Mc Graw Hill " 
    book2="Problem Solving with Algorithms and Data Structures using Python, by Brad Miller and 
    David Ranum "
    book1Link="https://www.pdfdrive.com/download.pdf?id=19408917&h=d79aa7bc7cd3f23b3d71f92ee810ccc9&u=cache&ext=pdf
    " 
    book2Link="https://www.pdfdrive.com/download.pdf?id=189216728&h=ae007a68c3c7fe1e5abecbad87d16703&u=cache&ext=pdf
    " 
    int21="#" mid21="#" end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}